(() => {
  const isRTL = () => document.documentElement.getAttribute("dir") === "rtl";

  function getRealTotal(sliderComponent) {
    // Dawn sliders usually have a .slider UL/div with LI children
    const slider =
      sliderComponent.querySelector(".slider") ||
      sliderComponent.querySelector('[role="list"]');

    if (!slider) return null;

    // Count only direct LI children if present, otherwise count direct children
    const lis = slider.querySelectorAll(":scope > li");
    if (lis && lis.length) return lis.length;

    const kids = slider.children ? slider.children.length : null;
    return kids || null;
  }

  function fixOne(sliderComponent) {
    const totalEl = sliderComponent.querySelector(".slider-counter--total");
    if (!totalEl) return;

    const realTotal = getRealTotal(sliderComponent);
    if (!realTotal) return;

    // Only correct if different
    if (totalEl.textContent.trim() !== String(realTotal)) {
      totalEl.textContent = String(realTotal);
    }

    // Optional: also fix "of X" label if theme uses it
    const ofEl = sliderComponent.querySelector(".slider-counter--total ~ .visually-hidden");
    if (ofEl && /of/i.test(ofEl.textContent)) {
      // keep as-is (not required)
    }
  }

  function run() {
    if (!isRTL()) return;
    document.querySelectorAll("slider-component").forEach(fixOne);
  }

  // Run on load + after dynamic updates
  document.addEventListener("DOMContentLoaded", run);
  document.addEventListener("shopify:section:load", run);

  // Dawn triggers these on product changes/section re-render in many setups
  document.addEventListener("variant:change", () => setTimeout(run, 50));
  document.addEventListener("cart:refresh", () => setTimeout(run, 50));

  // Catch any JS that updates the counter later
  const mo = new MutationObserver(() => run());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();